import { PhoneIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import { formatPhoneWithDashes } from '@rsos/utils';
import { DateInformation } from './DateInformation';
import { LocationInformation } from './LocationInformation';

interface Props {
  isInternational: boolean;
  callerID: string;
  timestamp: number;
}

export const CollapsedHeaderData = ({
  callerID,
  isInternational,
  timestamp,
}: Props) => {
  return (
    <Box>
      <Box horizontal align="center">
        <PhoneIcon
          color="panePrimaryText"
          viewboxHeight={16}
          viewboxWidth={14}
          width={12}
        />
        <Text
          color="panePrimaryText"
          fontWeight="bold"
          lineHeight="normal"
          marginLeft={2}
        >
          {isInternational ? callerID : formatPhoneWithDashes(callerID)}
        </Text>
      </Box>
      <DateInformation timestamp={timestamp} />
      <LocationInformation />
    </Box>
  );
};
